module.exports = __webpack_public_path__ + "static/media/logo_light_fka.976bb4af.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/logo_light_fka.png
// module id = 1601
// module chunks = 0